
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { FooterConfigService } from "app/homepage-configuration/footer-config/footer-config.service";
import { FooterCopyRightResource } from "app/models/FooterCopyRightResource";
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { TranslateService } from "@ngx-translate/core";
import { NotificationsService } from "angular2-notifications";
import { Router } from '@angular/router';
import { FooterCellListResource } from "app/models/FooterCellListResource";
@Component({
  selector: 'vbn-footer-style-config',
  templateUrl: './footer-style-config.component.html',
  providers:[FooterConfigService],
  styleUrls: ['./footer-style-config.component.scss']
})
export class FooterStyleConfigComponent implements OnInit {

  footerCopyRightResource: FooterCopyRightResource;
  errorMessage: any;
  saveErrors: boolean = false;
  footerCellListResourceActive: FooterCellListResource;
  showShiftBtn: boolean = false;
  showConfirmation;
  user = localStorage.getItem("_user");

  constructor(
    private footerConfigService: FooterConfigService,
    private fb: FormBuilder, 
    private translate: TranslateService, 
    private _notificationService: NotificationsService,
    private router: Router) {
      this.footerCopyRightResource = new FooterCopyRightResource();
      this.footerCellListResourceActive = new FooterCellListResource();
  }

  ngOnInit() {
    this.getFooterText();
    this.getAllFooterCellActive();
  }

  getAllFooterCellActive() {
    this.footerConfigService.getCellActive('/admin/footer/cell/getActive?email=' + this.user)
      .subscribe(
      body => {
        this.footerCellListResourceActive = body;
        if(this.footerCellListResourceActive != null){
          if(this.footerCellListResourceActive.footerCellListResource != null){
            let count = this.footerCellListResourceActive.footerCellListResource.length;
            if(count>=2){
              this.showShiftBtn = true;
            }
          }
        }
      },
      error => this.errorMessage = <any>error)
  }

  getFooterText() {
    this.footerConfigService.getFooterCopyrightText('/admin/footer/getFooterCopyRight?email=' + this.user)
      .subscribe(
      body => {
        this.footerCopyRightResource = body;
      },
      error => this.errorMessage = <any>error)
  }

  footerCopyrightForm = this.fb.group({
    textRo: ['', [Validators.maxLength(200)]],
    textEn: ['', [Validators.maxLength(200)]],
    textDe: ['', [Validators.maxLength(200)]],
    textFr: ['', [Validators.maxLength(200)]],
  })

  saveFooterCopyRightText() {
    // this.saveErrors = true
    // if (!this.footerCopyrightForm.valid) {
    //   Observable.forkJoin(
    //     this.translate.get('Error'),
    //     this.translate.get('Invalid fields!')
    //   ).subscribe((res) => {
    //     this._notificationService.create(res[0], res[1], 'error')
    //   })
    //   return
    // }
    //this.footerCopyRightResource.textFr ='-';
    this.footerCopyRightResource.userEmail = this.user
    this.footerConfigService.saveEditFooterCopyright(`/admin/footer/editFooterCopyright`, this.footerCopyRightResource)
      .subscribe(
      body => {
        if (body.errorCode == 9080 || body.errorCode == 9082) {
            observableForkJoin(
              this.translate.get('Error'),
              this.translate.get('You must set the footer background color!')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
            return
          }
          if (body.errorCode == 9081 || body.errorCode == 9083) {
            observableForkJoin(
              this.translate.get('Error'),
              this.translate.get('You must set the footer text color!')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
            return
          }
        this.footerCopyRightResource = body
        observableForkJoin(
          this.translate.get('Success'),
          this.translate.get('Footer colors saved with success!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'success')
        })
      },
      error => console.error(error))
  }
}
